import React, { Component } from 'react';
import styled from 'styled-components';
import validator from 'validator';

import * as form from '../form';
import { dark, white } from 'react-components/dist/values/colors/colors';
import { secondaryFont } from 'react-components/dist/values/fonts/fonts';
import { Button } from 'react-components/dist/buttons/Button';

const Wrapper = styled.div``;

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  & > div {
    width: 49.5%;
  }
`;

const SubmitBtn = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  align-items: center;
`;

const Message = styled.div`
  color: ${props => (props.dark ? dark : white)};
  font: ${secondaryFont.large};
  margin-right: 6px;
`;

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      company: '',
      field: '',
      message: '',
      honeypot: '',
      source: this.props.source,
      invalidEmail: false,
      invalidName: false,
      msg: ''
    };
    this.form = React.createRef();
  }

  handleChange = (el, val) => {
    this.setState({
      ...this.state,
      [el]: val
    });
  };

  submitForm = () => {
    if (!validator.isEmail(this.state.email)) {
      this.setState({
        ...this.state,
        msg: this.props.lang === 'fr' ? 'Adresse courriel invalide' : 'Invalid Email Address',
        invalidEmail: true
      });
      return;
    } else if (this.state.name === '') {
      this.setState({
        ...this.state,
        msg: this.props.lang === 'fr' ? 'SVP entrez votre nom complet' : 'Please fill in your name',
        invalidName: true
      });
      return;
    }
    let formData = new FormData();
    formData.append('name', this.state.name);
    formData.append('email', this.state.email);
    formData.append('company', this.state.company);
    formData.append('field', this.state.field);
    formData.append('message', this.state.message);
    formData.append('honeypot', this.state.honeypot);
    formData.append('source', this.state.source);

    fetch('/api/saveMessage.php', { method: 'POST', body: formData })
      .then(function(response) {
        return response.text();
      })
      .then(body => {
        try {
          let answer = JSON.parse(body);
          if (answer.success) {
            this.form.current.reset();
            this.setState({
              ...this.state,
              name: '',
              email: '',
              company: '',
              field: '',
              message: '',
              invalidEmail: false,
              invalidName: false,
              msg:
                this.props.lang === 'fr'
                  ? 'Merci de votre intérêt, nous vous répondrons dans les plus brefs délais!'
                  : 'Thanks for reaching out to us, we will answer as fast as possible!'
            });
          } else {
            this.setState({
              ...this.state,
              msg:
                this.props.lang === 'fr'
                  ? "Une erreur s'est produite, SVP réessayez!"
                  : 'An error occurred, please try again!'
            });
          }
        } catch (e) {
          this.setState({
            ...this.state,
            msg:
              this.props.lang === 'fr'
                ? "Une erreur s'est produite, SVP réessayez!"
                : 'An error occurred, please try again!'
          });
        }
      });
  };

  render() {
    return (
      <Wrapper>
        <form ref={this.form}>
          <div style={{ position: 'absolute', right: 9999999999 }}>
            <form.Input
              light={this.props.light}
              dark={this.props.dark}
              placeholder="Put Name Here"
              type="text"
              onChange={e => this.handleChange('honeypot', e)}
              name={'name'}
            />
          </div>
          <form.Input
            light={this.props.light}
            dark={this.props.dark}
            placeholder={this.props.lang === 'fr' ? 'Nom complet' : 'Name'}
            type="text"
            onChange={e => this.handleChange('name', e)}
            name={'name'}
            valid={this.state.invalidName}
          />
          <form.Input
            light={this.props.light}
            dark={this.props.dark}
            placeholder={this.props.lang === 'fr' ? 'Courriel' : 'Email'}
            type="email"
            onChange={e => this.handleChange('email', e)}
            name={'email'}
            valid={this.state.invalidEmail}
          />
          <Row>
            <form.Input
              light={this.props.light}
              dark={this.props.dark}
              placeholder={this.props.lang === 'fr' ? 'Compagnie' : 'Company'}
              type="text"
              onChange={e => this.handleChange('company', e)}
              name={'company'}
            />
            <form.Select
              light={this.props.light}
              dark={this.props.dark}
              placeholder={this.props.lang === 'fr' ? 'Domaine' : 'Field'}
              options={
                this.props.lang === 'fr'
                  ? ['Ville Intelligente', 'Arts et loisirs', 'Industriel']
                  : ['Smart City', 'Entertainment', 'Industrial']
              }
              onChange={e => this.handleChange('field', e)}
              name={'field'}
            />
          </Row>
          <form.Textarea
            light={this.props.light}
            dark={this.props.dark}
            placeholder="Message"
            onChange={e => this.handleChange('message', e)}
            name={'message'}
          />
          <SubmitBtn>
            <Message dark={this.props.dark}>{this.state.msg}</Message>
            <Button
              onClick={() => {
                this.submitForm();
              }}
              type="submit"
              light={!this.props.light}
            >
              {this.props.lang === 'fr' ? 'ENVOYER' : 'SEND'}
            </Button>
          </SubmitBtn>
        </form>
      </Wrapper>
    );
  }
}

export default ContactForm;
